export default __webpack_public_path__ + "static/media/Check.a46566b0.png";